import { Activity, CalendarDays, Check, FileText, Target, BoxIcon } from "lucide-react";
import { Card, CardContent } from "./Card";
interface Benefit {
  icon: BoxIcon;
  text: string;
}
const benefits: Benefit[] = [{
  icon: FileText,
  text: '+300 páginas de contenido estructurado'
}, {
  icon: CalendarDays,
  text: '+60 sesiones completas listas para dar'
}, {
  icon: Activity,
  text: 'Fisiología · Planificación · Físico · Táctica · Sesiones · Liderazgo · Desarrollo individual de la jugadora'
}, {
  icon: Target,
  text: 'Funciona desde el primer día en tu club o academia'
}];
const levels = ['Principiantes', 'Intermedios', 'Avanzados', 'Categorías formativas', 'Adultas', 'Alto rendimiento', 'Amateur'];
export function SystemSection() {
  return <section className="w-full bg-navy-dark py-14 text-white sm:py-16 lg:py-20" data-id="element-169" data-mp="2nuvm4ey0z069">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-170" data-mp="2it69wvz2gggl">
        <p className="mx-auto mb-8 max-w-4xl rounded-2xl border border-brandgreen/40 bg-brandgreen/10 px-5 py-4 text-center font-heading text-xs font-extrabold leading-5 tracking-[0.08em] text-brandgreen shadow-sm sm:mb-10 sm:px-8 sm:text-sm" data-id="element-171" data-mp="2dv4tkit0yv8t">SISTEMA NÚMERO 1 PARA ENTRENADORES DE FÚTBOL FEMENINO EN ARGENTINA</p>

        <div className="mb-8 text-center sm:mb-10" data-id="element-172" data-mp="u1k1mg74r966">
          <h2 className="font-heading text-4xl font-black leading-none tracking-tight text-white sm:text-5xl lg:text-6xl" data-id="element-173" data-mp="u2v3gah0m6un">MEGA PACK</h2>
          <p className="mt-2 font-heading text-3xl font-black leading-none tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-174" data-mp="1mpz4y5gwg31o">SISTEMA COMPLETO</p>
          <p className="mx-auto mt-4 max-w-3xl text-sm leading-6 text-gray-300 sm:text-lg" data-id="element-175" data-mp="1roaeef3a8bjd">7 Tomos + 5 Bonos — Todos los niveles — Toda la temporada resuelta.</p>
        </div>

        <div className="grid items-stretch gap-4 lg:grid-cols-[1.05fr_0.95fr] lg:gap-6" data-id="element-176" data-mp="1hpth70dr30ov">
          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-1" data-id="element-177" data-mp="1c3e9wydaigt">
            {benefits.map(({
            icon: Icon,
            text
          }) => <Card key={text} size="sm" className="border border-white/15 bg-navy-light text-white shadow-lg shadow-black/10" data-id="element-178" data-mp="6cr5aimlizb1">
                <CardContent className="flex h-full min-h-24 items-center gap-4 p-4 sm:p-5" data-id="element-179" data-mp="23z1nkt22s4rt">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-brandgreen/15 bg-brandgreen/15 text-brandgreen sm:h-14 sm:w-14" aria-hidden="true" data-id="element-180" data-mp="1z8bk5ld7mbzr">
                    <Icon size={27} strokeWidth={2.25} data-id="element-181" data-mp="1u7e0f4cjx9w5" />
                  </span>
                  <p className="font-heading text-base font-bold leading-6 text-white sm:text-lg" data-id="element-182" data-mp="1p815dwbj0wih">{text}</p>
                </CardContent>
              </Card>)}
          </div>

          <Card className="border border-brandgreen/40 bg-navy-light text-white shadow-xl shadow-black/15" data-id="element-183" data-mp="1ga8qgt9pvqvm">
            <CardContent className="flex h-full flex-col justify-center p-5 sm:p-7 lg:p-8" data-id="element-184" data-mp="1bbxgmijf9gde">
              <div className="flex items-start gap-3" data-id="element-185" data-mp="3am5hwm85swqo">
                <div className="mt-0.5 shrink-0 text-brandgreen" size={30} strokeWidth={2.25} aria-hidden="true" data-id="element-186" data-mp="35onaj09sipks" />
                <h3 className="font-heading text-2xl font-black leading-tight text-white sm:text-3xl" data-id="element-187" data-mp="3d8ofi4bw8m04">NIVELES Y ENFOQUES<br className="hidden sm:block" data-id="element-188" data-mp="3i67rsyp16opf" /> INCLUIDOS:</h3>
              </div>

              <ul className="mt-7 flex flex-wrap gap-2.5" aria-label="Niveles y enfoques incluidos" data-id="element-189" data-mp="3mx6c09d546xy">
                {levels.map(level => <li key={level} className="flex items-center gap-2 rounded-xl border border-white/20 bg-navy-dark px-3.5 py-3 font-heading text-sm font-bold text-white shadow-sm sm:px-4" data-id="element-190" data-mp="3rvrdec44ownz">
                    <Check className="shrink-0 text-brandgreen" size={18} strokeWidth={3} aria-hidden="true" data-id="element-191" data-mp="2z7c2o1s150ig" />
                    {level}
                  </li>)}
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}